/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DownloadCloudIcon
 */
export default class DownloadCloudIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15.046 16.12l-2.123 2.205V12c0-.575-.37-.958-.923-.958-.554 0-.923.383-.923.958v6.325l-2.123-2.204a.87.87 0 00-1.292 0 .951.951 0 000 1.341l3.692 3.834c.092.096.184.192.277.192.092.095.277.095.369.095.092 0 .277 0 .37-.095.092-.096.184-.096.276-.192l3.692-3.834a.951.951 0 000-1.341.87.87 0 00-1.292 0zm7.016-5.558c-1.016-1.437-2.677-2.395-4.524-2.395h-.553C15.6 3.95 11.262 1.554 7.108 2.608c-2.123.575-3.97 2.013-5.077 4.025-1.108 2.013-1.477 4.313-.923 6.613.369 1.341 1.015 2.587 1.938 3.546a.87.87 0 001.292 0 .951.951 0 000-1.342c-.646-.67-1.2-1.63-1.384-2.683A7.124 7.124 0 013.6 7.592c.923-1.534 2.308-2.684 3.97-3.067 3.415-.958 6.922 1.246 7.845 4.887.093.384.462.767.923.767h1.2c1.2 0 2.4.671 3.047 1.63.553.862.83 1.916.646 2.874-.185.959-.739 1.917-1.477 2.492-.462.287-.554.863-.185 1.342.185.287.462.383.739.383.184 0 .369-.096.554-.192 1.2-.862 2.03-2.204 2.307-3.737a7.487 7.487 0 00-1.107-4.409z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

